import './input.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { FileInput } from './file-input';

const FormInput = React.forwardRef(
  ({ name, placeholder, register, control, error, type, label, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const className = classNames({
      form__input: true,
      'form__input--error': !!error,
      'form__input--slim': !label,
      'form__input--password': type === 'password',
      'form__input--checkbox': type === 'checkbox'
    });

    const formItemClassName = classNames({
      form__item: true,
      'form__item--checkbox-wrapper': type === 'checkbox'
    });
    const inputType = showPassword ? 'text' : type;
    const isTextArea = type === 'textarea';
    const inputProps = {
      className,
      name,
      placeholder,
      ref,
      type: inputType,
      ...register,
      ...props
    };

    if (inputType === 'file') {
      return (
        <FileInput
          placeholder={placeholder}
          register={register}
          {...props}
          label={label}
          error={error}
          name={name}
          control={control}
        />
      );
    }

    return (
      <div className={formItemClassName}>
        {label && (
          <label className="form__label" htmlFor={name}>
            {label}
          </label>
        )}
        {isTextArea ? <textarea {...inputProps} rows="3" /> : <input {...inputProps} />}
        {type === 'password' && (
          <button
            type="button"
            className="form__input__icon"
            onClick={() => setShowPassword(!showPassword)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none">
              <g stroke="#150F2F" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
                <path d="M8.237 8.638a1.75 1.75 0 1 1-2.474-2.473m4.702 4.702A5.874 5.874 0 0 1 7 12.068c-4.083 0-6.417-4.666-6.417-4.666a10.763 10.763 0 0 1 2.952-3.465l6.93 6.93Zm-4.69-7.992A5.32 5.32 0 0 1 7 2.735c4.083 0 6.417 4.667 6.417 4.667a10.782 10.782 0 0 1-1.26 1.86L5.775 2.875ZM.583.985l12.834 12.833" />
              </g>
              <defs>
                <clipPath id="a">
                  <path fill="#fff" d="M0 0h14v14H0z" transform="translate(0 .402)" />
                </clipPath>
              </defs>
            </svg>
          </button>
        )}
        {error && (
          <span role="status" className="form__error">
            {error}
          </span>
        )}
      </div>
    );
  }
);

FormInput.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.node,
  type: PropTypes.oneOf([
    'url',
    'text',
    'textarea',
    'password',
    'tel',
    'search',
    'number',
    'email',
    'name',
    'date',
    'file',
    'checkbox',
    'phone'
  ]),
  register: PropTypes.object
};

FormInput.displayName = 'FormInput';

export { FormInput };
